// Formas adicionais do MESMO recebimento (pagamento dividido). A forma 1 continua no modal principal.
import React, { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { CheckCircle2, Plus, Trash2 } from 'lucide-react';
import api from '@/lib/api';

const brl = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);
const r2 = (v) => Math.round((Number(v) || 0) * 100) / 100;
let seq = 0;
export const newLine = (method = 'pix') => ({ id: `l${(seq += 1)}`, method, amount: '', account_id: '', installments: 1, fee_manual: '', fee_auto: 0, brand: '', nsu: '', authorization_code: '', last4: '' });
export const CARD_METHODS = ['card_debit', 'card_credit', 'pix_card'];
// Linha → corpo aceito pelo backend (settle-split / batch-settle splits)
export const lineBody = (l) => ({
  payment_method: l.method, amount: r2(l.amount), account_id: l.account_id || null,
  installments: ['card_credit', 'pix_card'].includes(l.method) ? Number(l.installments || 1) : 1,
  fee_amount: l.fee_manual !== '' && l.fee_manual !== null ? r2(l.fee_manual) : null,
  ...(CARD_METHODS.includes(l.method) ? { brand: l.brand || null, nsu: l.nsu || null, authorization_code: l.authorization_code || null, last4: l.last4 || null } : {}),
});
export const lineFee = (l) => (l.fee_manual !== '' && l.fee_manual !== null ? r2(l.fee_manual) : r2(l.fee_auto));

function ExtraLine({ line, idx, methods, onChange, onRemove, cardFields }) {
  const [accounts, setAccounts] = useState([]);
  const credit = ['card_credit', 'pix_card'].includes(line.method);
  const amount = r2(line.amount);
  useEffect(() => {
    api.get('/financial/accounts/receiving', { params: { payment_method: line.method } })
      .then(({ data }) => {
        const acc = data.accounts || [];
        setAccounts(acc);
        if (!acc.some((a) => a.id === line.account_id)) onChange({ account_id: ((acc.find((a) => a.padrao) || acc[0]) || {}).id || '' });
      }).catch(() => setAccounts([]));
  }, [line.method]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!line.account_id || !amount) { onChange({ fee_auto: 0 }); return; }
    const h = setTimeout(() => api.get('/financial/accounts/fee-quote', {
      params: { account_id: line.account_id, payment_method: line.method, installments: credit ? Number(line.installments || 1) : 1, amount },
    }).then(({ data }) => onChange({ fee_auto: r2(data.fee_amount) })).catch(() => onChange({ fee_auto: 0 })), 250);
    return () => clearTimeout(h);
  }, [line.account_id, line.method, line.installments, amount]); // eslint-disable-line react-hooks/exhaustive-deps
  const fee = lineFee(line);
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-2 space-y-2" data-testid={`ps-split-line-${idx}`}>
      <div className="flex items-center gap-2">
        <span className="text-[11px] font-bold text-slate-500">Forma {idx}</span>
        <select className="h-8 flex-1 rounded-md border px-1 text-[12px]" value={line.method} data-testid={`ps-split-method-${idx}`}
          onChange={(e) => onChange({ method: e.target.value, installments: 1, fee_manual: '' })}>
          {methods.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <button type="button" onClick={onRemove} className="text-rose-600" aria-label={`Remover forma ${idx}`} data-testid={`ps-split-remove-${idx}`}><Trash2 className="h-4 w-4" /></button>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Input type="number" step="0.01" min="0" placeholder="Valor (R$)" value={line.amount} className="h-8 text-[12px]"
          data-testid={`ps-split-amount-${idx}`} onChange={(e) => onChange({ amount: e.target.value })} />
        <select className="h-8 rounded-md border px-1 text-[12px]" value={line.account_id} data-testid={`ps-split-account-${idx}`}
          onChange={(e) => onChange({ account_id: e.target.value })}>
          <option value="">Conta de recebimento</option>
          {accounts.map((a) => <option key={a.id} value={a.id}>{a.nome}{a.provider ? ` · ${a.provider}` : ''}</option>)}
        </select>
        {credit && (
          <Input type="number" min="1" max="24" placeholder="Parcelas" aria-label="Parcelas do cartão" title="Parcelas do cartão" value={line.installments} className="h-8 text-[12px]"
            data-testid={`ps-split-installments-${idx}`} onChange={(e) => onChange({ installments: e.target.value })} />
        )}
        <Input type="number" step="0.01" min="0" placeholder={`Taxa auto ${brl(line.fee_auto)}`} aria-label="Taxa manual (opcional)" title="Taxa manual (opcional)" value={line.fee_manual} className="h-8 text-[12px]"
          data-testid={`ps-split-fee-${idx}`} onChange={(e) => onChange({ fee_manual: e.target.value })} />
        {cardFields && CARD_METHODS.includes(line.method) && (
          <>
            <Input placeholder="Bandeira" value={line.brand} className="h-8 text-[12px]" data-testid={`ps-split-brand-${idx}`} onChange={(e) => onChange({ brand: e.target.value })} />
            <Input placeholder="NSU" value={line.nsu} className="h-8 text-[12px]" data-testid={`ps-split-nsu-${idx}`} onChange={(e) => onChange({ nsu: e.target.value })} />
            <Input placeholder="Autorização" value={line.authorization_code} className="h-8 text-[12px]" data-testid={`ps-split-auth-${idx}`} onChange={(e) => onChange({ authorization_code: e.target.value })} />
            <Input placeholder="4 últimos" value={line.last4} className="h-8 text-[12px]" data-testid={`ps-split-last4-${idx}`} onChange={(e) => onChange({ last4: e.target.value })} />
          </>
        )}
      </div>
      <p className="text-[11px] text-slate-600" data-testid={`ps-split-net-${idx}`}>
        Taxa {brl(fee)}{line.fee_manual !== '' ? ' (manual)' : ' (automática)'} · Líquido <b>{brl(r2(amount - fee))}</b>
      </p>
    </div>
  );
}

export function SplitPaymentLines({ extras, setExtras, methods, line1, devido, cardFields = true, addLabel = 'Adicionar forma de pagamento' }) {
  const upd = (id) => (patch) => setExtras((xs) => xs.map((x) => (x.id === id ? { ...x, ...patch } : x)));
  const distribuido = r2(line1.amount + extras.reduce((s, l) => s + r2(l.amount), 0));
  const restante = r2(devido - distribuido);
  const fees = r2(line1.fee + extras.reduce((s, l) => s + lineFee(l), 0));
  return (
    <div className="space-y-2" data-testid="ps-split">
      {extras.map((l, i) => (
        <ExtraLine key={l.id} line={l} idx={i + 2} methods={methods} onChange={upd(l.id)} cardFields={cardFields}
          onRemove={() => setExtras((xs) => xs.filter((x) => x.id !== l.id))} />
      ))}
      <button type="button" onClick={() => setExtras((xs) => [...xs, newLine(xs.length ? 'pix' : 'cash')])}
        className="inline-flex items-center gap-1 rounded-full border border-dashed border-violet-300 px-3 py-1.5 text-xs font-semibold text-violet-700 hover:bg-violet-50"
        data-testid="ps-split-add"><Plus className="h-3.5 w-3.5" /> {addLabel}</button>
      {extras.length > 0 && (
        <div className="grid grid-cols-3 gap-2 rounded-lg border-2 border-violet-100 bg-violet-50 p-2 text-center" data-testid="ps-split-summary">
          <div><p className="text-[10px] font-bold uppercase text-slate-500">Valor devido</p><p className="text-sm font-bold" data-testid="ps-split-devido">{brl(devido)}</p></div>
          <div><p className="text-[10px] font-bold uppercase text-slate-500">Distribuído</p><p className="text-sm font-bold" data-testid="ps-split-distribuido">{brl(distribuido)}</p></div>
          <div><p className="text-[10px] font-bold uppercase text-slate-500">Restante</p>
            <p className={`text-sm font-bold ${restante < -0.004 ? 'text-rose-600' : restante > 0.004 ? 'text-amber-700' : 'text-emerald-700'}`} data-testid="ps-split-restante">
              {brl(restante)} {Math.abs(restante) <= 0.004 && <CheckCircle2 className="inline h-4 w-4" />}
            </p></div>
          <p className="col-span-3 text-[11px] text-slate-600" data-testid="ps-split-totais">
            Bruto {brl(distribuido)} · Taxas {brl(fees)} · Líquido {brl(r2(distribuido - fees))}
            {restante < -0.004 && <b className="block text-rose-600">A soma passa do valor devido + encargos.</b>}
            {restante > 0.004 && <span className="block text-amber-700">Recebimento parcial: o título ficará com saldo de {brl(restante)}.</span>}
          </p>
        </div>
      )}
    </div>
  );
}
